module.exports = __webpack_public_path__ + "static/media/pokemon_frame.574f208e.svg";